<template>
  <footer class="bg-white absolute left-0 bottom-0 right-0">
    <div class="max-w-7xl mx-auto py-8 px-6 sm:px-8 flex flex-col items-center lg:px-8
    justify-center">
      <div class="mb-1">
        <p class="text-center text-base leading-6 text-gray-500">
          &copy; {{ new Date().getFullYear() }} LeverEdge Association. All rights reserved.
          <br class="sm:hidden" />
          <a
            href="https://leveredge.org/terms-of-use"
            target="_blank"
            rel="noopener noreferrer"
            class="underline hover:opacity-75"
          >
            Terms of Use
          </a>
          -
          <a
            href="https://leveredge.org/privacy"
            target="_blank"
            rel="noopener noreferrer"
            class="underline hover:opacity-75"
          >
            Privacy Policy
          </a>
        </p>
      </div>
      <div>
        <p class="text-center text-sm leading-6 text-gray-500">
          This site is protected by reCAPTCHA and the Google
          <a
            class="underline hover:opacity-75"
            href=”https://policies.google.com/privacy”
          >Privacy Policy</a>
          and
          <a
            class="underline hover:opacity-75"
            href=”https://policies.google.com/terms”
          >Terms of Service</a> apply.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'PageFooter',
};
</script>
